module.exports = __webpack_public_path__ + "static/media/godOfMars-1.80b7bbc9.png";